import React, {FC, memo, useCallback, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions as modal} from "../../store/sliceModal";
import yamahaImg from "../../image/yamaha.webp"
import {ReceiverArticle, ReceiverImg, ReceiverText} from "./ReceiverStyle";
import {IReceiver} from "../../store/sliceWebsocket";
import Ticker from "./Ticker";
import {replaceUnderline} from "../../utils/Util";


const Receiver: FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const receiver: IReceiver = useSelector((state: IRootState) => state.websocket.receiver)

    const mode = useCallback((): string => {
        if (receiver?.mode?.radio) {
            return "Радио"
        }
        if (receiver?.mode?.netRadio) {
            return "Net-Радио"
        }
        if (receiver?.mode?.usb) {
            return "USB"
        }
        if (receiver?.mode?.server) {
            return "Server"
        }
        if (receiver?.mode?.bluetooth) {
            return "Bluetooth"
        }
        return "Нет сети"
    }, [receiver?.mode])

    const info = useCallback((): string => {

        if (!receiver.power) {
            return "Выключен"
        }
        if (receiver?.playNow?.wave && receiver?.mode?.netRadio) {
            return receiver?.playNow?.wave
        }
        if (receiver?.playNow?.wave && receiver?.mode?.radio) {
            return `${Number(receiver?.playNow?.wave) / 1000} FM`
        }
        if (receiver?.playNow?.artist) {
            return `${receiver?.playNow?.artist}`
        }
        return "Включен"

    }, [receiver?.power, receiver?.playNow])


    return (
        <ReceiverArticle onClick={() => dispatch(modal.showReceiverModal())}>
            <ReceiverImg src={yamahaImg} alt={"Ресивер"}/>
            <ReceiverText>
                {mode()}
            </ReceiverText>
            <ReceiverText>
                {info()}
            </ReceiverText>
            {receiver?.playNow?.track && <ReceiverText>
                {replaceUnderline(receiver?.playNow?.track)}
            </ReceiverText>}
        </ReceiverArticle>
    )
}


export default memo(Receiver)

